<template>
  <div class="recommend-focus-news-item-container">
    <a v-if="!data.is_pdf" target="_blank" class="recommend-focus-news-item-title" :href="data.url">{{data.title}}</a>
    <router-link @click.native="toPdfPage" class="recommend-focus-news-item-title" v-else target="_blank" :to="{path: '/pdf-detail'}">
      <span>{{data.title}}</span>
    </router-link>
    <div v-for="(item, index) in data.companies" :key="index" class="row focus-news-item-companies">
      <div @click="toCompanyDetail(item.name)" class="focus-news-item-company">{{item.stock_code}}</div>
      <RecommendEventPopover :item="item"></RecommendEventPopover>
      <div></div>
    </div>
    <div class="row focus-news-item-source-date">
      <div class="focus-news-item-source">{{data.source}}</div>
      <div>{{data.date}}</div>
    </div>
    <sn-news-dialog ref="snNewsDialog"></sn-news-dialog>
  </div>
</template>

<script>
import SnNewsDialog from '@/components/common/SnNewsDialog';
import RecommendEventPopover from '@/components/recommend/RecommendEventPopover';
import localStorageHelper from '@/helpers/localStorageHelper';

export default {
  name: 'recommend-news-list-item',
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    toPdfPage() {
      localStorageHelper.setItem('PDF_DETAIL_DATA', JSON.stringify(this.data));
    },
    onCheckDetailClick(id) {
      this.$refs.snNewsDialog.checkDetail(id);
    },
    toCompanyDetail(res) {
      const routeUrl = this.$router.resolve({
        path: '/result', 
        query: {
          q: res
        }  
      });
      window.open(routeUrl.href, '_blank');
      // this.$router.push({
      //   name: 'result-page',
      //   query: {
      //     q: res
      //   }
      // });
    }
  },
  components: {
    SnNewsDialog,
    RecommendEventPopover
  }
};
</script>

<style lang="scss" scoped>
  .recommend-focus-news-item-container {
    padding: 16px 0;
    box-shadow: inset 0px -1px 0px 0px#f7f7fa;
    .recommend-focus-news-item-title {
      display: inline-block;
      margin-bottom: 8px;
      color: #171f46;
      font-size: 16px;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .focus-news-item-companies {
      // flex-wrap: wrap;
      .focus-news-item-company {
        margin: 0 8px 8px 0;
        padding: 0 8px;
        border-radius: 2px;
        border: solid 1px rgba(69, 168, 204, 0.4);
        color: rgba(69, 168, 204, 0.8);
        font-size: 14px;
        cursor: pointer;
        &:hover {
          border: 1px solid #45a8cc;
          color: #45a8cc;
        }
      }
    }
    .focus-news-item-source-date {
      height: 17px;
      line-height: 17px;
      color: #9ea1b4;
      font-size: 12px;
      .focus-news-item-source {
        margin-right: 10px;
      }
    }
  }
</style>

